'use client';

import { useRef, useEffect } from 'react';

// Context
import useOnlineProfileCtx, {
  OnlineProfileProvider,
} from '@src/context/online-profile-ctx';

// Components
import ListPropertyOrganism from '@src/components/organism/online-profile/list-property/list-property';
import ProfileOrganism from '@src/components/organism/online-profile/profile/profile';
import FilterAndSearchOrganism from '@src/components/organism/online-profile/filter-and-search/filter-and-search';

// Components shared
import Navbar from '@src/components/organism/shared/navbar-online-profile';
import NavbarMobile from '@src/components/organism/shared/navbar-mobile-online-profile';
import Footer from '@src/components/organism/shared/footer-online-profile';
import GoldenProperty from '@src/components/organism/shared/golder-property/golder-property';
import Loader from '@src/components/loader';
import ProfileOrganismInactive from '@src/components/organism/shared/profile-inactive';

const OnlineProfile = () => {
  const refListProperty = useRef(null);
  const refProfile = useRef(null);

  const handleScrollToListProperty = () => {
    refListProperty.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleScrollToProfile = () => {
    refProfile.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const { onlineProfile, username, isUserInactive, isLoadingOnlineProfile } =
    useOnlineProfileCtx();

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      window.location.hash === '#list-property'
    ) {
      setTimeout(() => {
        refListProperty.current?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, []);

  if (isLoadingOnlineProfile) {
    return <Loader />;
  }

  return (
    <div ref={refProfile}>
      <Navbar
        handleScrollToProfile={handleScrollToProfile}
        handleScrollToListProperty={handleScrollToListProperty}
        onlineProfile={onlineProfile}
        id={username}
      />
      <div className="sticky top-0 z-50 hidden dd2-xl:block">
        <NavbarMobile
          handleScrollToProfile={handleScrollToProfile}
          handleScrollToListProperty={handleScrollToListProperty}
          onlineProfile={onlineProfile}
          id={username}
        />
      </div>

      {isUserInactive ? (
        <div className="section-container bg-[#FAFAFA]">
          <div className="max-container">
            <ProfileOrganismInactive onlineProfile={onlineProfile} />
          </div>
        </div>
      ) : (
        <div className="section-container bg-[#FAFAFA]">
          <div className="max-container">
            <ProfileOrganism />
          </div>
          <div className="max-container dd2-xl:px-6">
            <div ref={refListProperty}>
              <FilterAndSearchOrganism />
              <ListPropertyOrganism />
            </div>
          </div>
        </div>
      )}
      <GoldenProperty />

      <Footer onlineProfile={onlineProfile} id={username} />
    </div>
  );
};

const WrapperProvider = () => {
  return (
    <OnlineProfileProvider>
      <OnlineProfile />
    </OnlineProfileProvider>
  );
};

export default WrapperProvider;
